import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ApiGridFilters } from '@app/infrastructure/data-list/grid/api-grid-filters/api-grid-filters';
import { ApiGrid } from '@app/infrastructure/data-list/grid/api-grid/api-grid';
import { IGridColumnConfig } from '@app/infrastructure/data-list/grid/grid-column-config.model';
import { GridType, IRowConfig, RowCustomClassesFn } from '@app/infrastructure/data-list/grid/grid.model';
import { InsertAtIndexFn } from '@app/infrastructure/data-list/table/directives/custom-row.directive';
import { UnsubscribeService } from '@app/infrastructure/unsubscribe/unsubscribe.service';
import { CommitmentListApiService } from '@modules/potential-save-modal/commitment-list/commitment-list-api.service';
import {
	COMMITMENT_GRID,
	COMMITMENT_GRID_FILTER,
	COMMITMENT_GRID_PROVIDERS,
} from '@modules/potential-save-modal/commitment-list/commitment-list.provider';
import { CommitmentListService } from '@modules/potential-save-modal/commitment-list/commitment-list.service';
import {
	COMMITMENT_COLUMNS,
	CommitmentTableCells,
	ICommitmentDTO,
	ICommitmentFilters,
	ICommitmentTotalDTO,
} from '@modules/potential-save-modal/commitment-list/commitment.model';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedHelper } from '@shared/helpers/shared.helper';

@Component({
	selector: 'app-commitment-list',
	templateUrl: './commitment-list.component.html',
	styleUrls: ['./commitment-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [UnsubscribeService, COMMITMENT_GRID_PROVIDERS, CommitmentListApiService, CommitmentListService],
})
export class CommitmentListComponent {
	@Input() public productLabel: string = '';
	@Input() public exportData: any[] = [];
	@Output() public close: EventEmitter<void> = new EventEmitter();

	public readonly commitmentColumns: IGridColumnConfig<ICommitmentDTO>[] = COMMITMENT_COLUMNS;
	public readonly commitmentTableCells: typeof CommitmentTableCells = CommitmentTableCells;
	public readonly gridType: GridType = GridType.likeMaterial;
	public readonly insertCustomRowAtIndexFn: InsertAtIndexFn<ICommitmentDTO> = (
		defaultRows: IRowConfig<ICommitmentDTO>[],
	) => defaultRows.length;
	public readonly customRowClassesFn: RowCustomClassesFn = (rowData: ICommitmentDTO) =>
		rowData.isExpired ? 'expired' : '';
	public readonly commitmentTotal$: Observable<ICommitmentTotalDTO> = this.commitmentListService.commitmentTotal$;

	constructor(
		@Inject(COMMITMENT_GRID_FILTER) public readonly apiGridFilters: ApiGridFilters<ICommitmentFilters>,
		@Inject(COMMITMENT_GRID) public apiGrid: ApiGrid<ICommitmentDTO, ICommitmentFilters>,
		public commitmentListApiService: CommitmentListApiService,
		public commitmentListService: CommitmentListService,
		private unsubscribe$: UnsubscribeService,
	) {}

	public export(): void {
		if (!this.productLabel) {
			return;
		}
		this.commitmentListApiService
			.exportCsv()
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((data) => SharedHelper.downloadCSV(data, 'existing_ris_and_sps.csv'));
	}
}
